import React from "react";
import { Card, Statistic } from "antd";
import { COLORS } from "../../../../consts";

const getFulfilledColor = (type, val) => {
  if (val && type === 1) return COLORS.successGreen;
  if (val && type === 2) return COLORS.primaryOrange;
  if (val && type === 3) return COLORS.primaryBlue;
  return COLORS.darkerGray;
};

const SpinachDashboardStats = ({
  expandedGroups,
  setExpandedGroups,
  type1Count,
  type2Count,
  type3Count,
  greenHouseLabel,
  renderExceedList,
  renderMidStageList,
  renderEarlyMidStageList,
}) => {
  return (
    <div className="flex flex-row sm:flex-col gap-4 w-full my-6">
      {/* Ready for Harvest => type=1 */}
      <Card
        variant="outlined"
        className="w-full flex-1 min-w-0 rounded-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-100"
        onClick={() => {
          const isExpanded = expandedGroups.includes("1");
          if (!isExpanded) setExpandedGroups([...expandedGroups, "1"]);
          document
            .getElementById("collapse-group-1")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
      >
        <Statistic
          title={
            <span>
              Ready for harvest (
              <span
                style={{
                  color: getFulfilledColor(1, type1Count),
                  fontWeight: "bold",
                }}
              >
                {type1Count} {greenHouseLabel}s
              </span>
              )
            </span>
          }
          styles={{ content: { color: getFulfilledColor(1, type1Count) } }}
          valueRender={renderExceedList}
        />
      </Card>

      {/* Mid Stage – Type2 (unchanged) */}
      <Card
        variant="outlined"
        className="w-full flex-1 min-w-0 rounded-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-100"
        onClick={() => {
          const isExpanded = expandedGroups.includes("2");
          if (!isExpanded) setExpandedGroups([...expandedGroups, "2"]);
          document
            .getElementById("collapse-group-2")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
      >
        <Statistic
          title={
            <span>
              Mid Stage (
              <span
                style={{
                  color: getFulfilledColor(2, type2Count),
                  fontWeight: "bold",
                }}
              >
                {type2Count} {greenHouseLabel}s
              </span>
              )
            </span>
          }
          valueRender={renderMidStageList}
          styles={{ content: { color: getFulfilledColor(2, type2Count) } }}
        />
      </Card>

      <Card
        variant="outlined"
        className="w-full flex-1 min-w-0 rounded-md hover:shadow-2xl transition-shadow duration-300 transform hover:scale-100"
        onClick={() => {
          const isExpanded = expandedGroups.includes("3");
          if (!isExpanded) setExpandedGroups([...expandedGroups, "3"]);
          document
            .getElementById("collapse-group-3")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        }}
      >
        <Statistic
          title={
            <span>
              Early‑Mid Stage (
              <span
                style={{
                  color: getFulfilledColor(3, type3Count),
                  fontWeight: "bold",
                }}
              >
                {type3Count} {greenHouseLabel}s
              </span>
              )
            </span>
          }
          valueRender={renderEarlyMidStageList}
          styles={{ content: { color: getFulfilledColor(3, type3Count) } }}
        />
      </Card>
    </div>
  );
};

export default SpinachDashboardStats;
